export default __webpack_public_path__ + "static/media/arizona_person_icon.d07391df.png";